/**
 * service-directory.js
 */

export const ServiceDirectory = (function () {

    let init = function () {
        serviceDirectoryInit();
    }

    return {
        init: init
    }

}());


function serviceDirectoryInit()
{
    window.tableStateCache = {};

    // Temporarily disabled (see https://www.pivotaltracker.com/story/show/186040706)
    // preReadTableSettings();

    $("#service-directory-loading").show();

    // loads services table
    $('#services-table').bootstrapTable({
        formatNoMatches: function () {
            $(".loading-text").text("There are currently no services listed.");
            $(".animation-wrap").hide();
            return '';
        }
    });

    // Are we in the SP app or not?
    let inSP = $('#directory-table-view').length > 0 ? 0 : 1;

    // toggle between table and card view
    $('#toggle-button').on('click', function(e) {
        if (!inSP) {      // if not in SP app
           $('#services-table').bootstrapTable('toggleCustomView');
        } else {                                            // in the SP app (not custom view)
           $('#services-table').bootstrapTable('toggleView');
        }
    });


    // This event is fired when the bootstrap-table custom view has been rendered
    $('#services-table').on('custom-view-post-body.bs.table', function(e) {
        // set handler to show service page if custom card clicked
        $(".service-card").on('click', function(e) {
            let sid = ($(this).attr('data-sid'));
            window.location.href = '/service-directory/service/' + sid;
        });
    });

    // This event is fired when the bootstrap-table table view has been rendered
    $('#services-table').on('post-body.bs.table', function(e) {
        if (!inSP) {    // not applicable to SP app
            // set handler to show service page if table row clicked
            $("#services-table > tbody > tr").on('click', function(e) {
                let sid = $(".service_id", this).html();
                window.location.href = '/service-directory/service/' + sid;
            });
        }
    });


    // version 1.22.1 of bootstrap-table has a bug where their custom view button is not
    // being hidden. So we are doing that manually here.
    // test '#directory-table-view' is present means we are not in the SP app.
    if ($('#directory-table-view').length > 0) {
       $("button[name='customView']").hide();
    }


    // if close cross button of alert message clicked then hide the message
    $("#service-form-alert .close").on('click', function() {
        $('#service-form-alert').addClass('d-none');
    });

    $(".back-button").on('click', function() {
        history.back();
    });

    $("#service-directory-loading").hide();

};


/**
 * Get data for bootstrap table.
 * This function is configured in the boostrap-table (data-ajax="tableGetServiceData")
 * @param {object} params - parameters for pagination, search etc.
 */
window.tableGetServiceData = function (params) {

    let url = '/service-directory/table-get-service-data';

    $.ajax({
        method: "GET",
        dataType: 'json',
        url: url + '/' + $.param(params.data),
    }).done(function (data) {
        if (data) {
            if (data.total > 0) {
                params.success(data);
            }
        }
    }).fail(function(err) {
        Util.toggleAlert('#service-directory-alert', err.responseJSON.message, 'alert-warning', -1);
    });

}


/**
 * customStorageSet - boostrap-table calls this to set state variables
 * for the state of the table. E.g. page number, search text, card/table view
 * @param {string} param - the type of value to save (e.g. page number, search text etc.)
 * @param {string} value - the value to save.
 */
window.serviceDirectoryCustomStorageSet = function(param, value) {

    let data = JSON.stringify({
        "instance": '0',
        "setting_name": param,
        "setting_value": String(value)
    });


    let promise = ajaxCall('/usersettings-write', data);

    promise.done(function(response) {
        if (response) {
            return(response.data);
        }
    });

};


/**
 * This function reads all the table settings in one ajax call and stores them in
 * the window.tableStateCache global object to act as a cache.
 * When bootstrap-table makes its calls to get the settings (multiple calls)
 * instead of making multiple ajax calls we return values from window.tableStateCache
 *
 * @returns Boolean
 */
window.preReadTableSettings = function() {

    let table_prefix = $("#services-table").attr('data-cookie-id-table');
    let data = JSON.stringify({
        "instance": '0',
        "setting_name": table_prefix + '%',
        "operator": 'LIKE'
    });


    // This ajax call needs to be synchronous to ensure data has been read
    // when requested by bootstrap-table
    let promise = ajaxCall('/usersettings-read', data, 'POST', false);

    promise.done(function(response) {
        if (response) {
            // loop through the table settings returned from userSettings
            // and add them to the cache
            for (const key in response.data) {
                Object.assign(
                    window.tableStateCache,
                    {[response.data[key]['var_name']] : response.data[key]['var_value']}
                );
            }
        }
    });

    promise.fail(function(error) {
        Util.toggleAlert('#service-directory-alert', error.responseJSON.message, 'alert-warning', -1);
        return false;
    });

    return true;

}


/**
 * customStorageGet - boostrap-table calls this to get any saved variables
 * for the state of the table. E.g. page number, search text, card/table view
 *
 * @param {string} param - the type of value requested (e.g. page number, search text etc.)
 */
window.serviceDirectoryCustomStorageGet = function(param) {

    // if the setting is present in the cache
    if (window.tableStateCache[param]) {
        return window.tableStateCache[param];
    }

    return null;

};

// defined in the service directory bootstrap-table but not used
window.serviceDirectoryCustomStorageDelete = function() {
};


/**
 * Post/Get ajax call to query for data
 * @param {string} endpoint string containing the URL to which the request is sent.
 * @param {*} data data to be sent to the server.
 * @param {string} type - ajax call type (defaults to POST)
 * @param {boolean} is_asynch - if the call is synchronous or asynchronous
 * @returns Deferred object response
 */
let ajaxCall = function(endpoint, data, type = 'POST', is_asynch = true) {

    let csrf = Util.getCSRF();

    return $.ajax({
      url: endpoint,
      type: type,
      data: data,
      async: is_asynch,
      cache: is_asynch,

      headers: {
        'x-csrf-token': csrf
      },
      dataType: "json",
      contentType: "application/json",
      timeout: 10000,  // set timeout to 10 seconds
    });
  }



/**
 * SPactionsFormatter defines the icons for the formatter column for the SP table.
 * @param {string} value - the field value.
 * @param {object} row - the row record data.
 * @param {integer} index the row index
 */
window.SPactionsFormatter = function(value, row, index) {

    let disable = '';

    if (row.status == 'Live') {
        disable = 'disabled';
    }

    let startDiv = `<div class="d-flex align-items-center justify-content-around">`;
    let view = `<a href="/service-directory/review/${row.service_id}" data-id="${row.id}"
        data-status="${row.status}" class="view mr-2"
        data-toggle="tooltip" data-placement="top" title="View Service">
        <em class="fas fa-eye fa-lg"></em>
        </a>`;
    let edit = `<button type="button" data-id="${row.id}"
        class="btn text-primary edit p-0"
        data-toggle="tooltip" data-placement="top" title="Edit Service"
        ${disable}>
        <i class="fas fa-edit fa-lg"></i>
        </button>`;
    let clone = `<button type="button" data-id="${row.id}"
        class="btn text-primary activate p-0 mr-2"
        data-toggle="tooltip" data-placement="top" title="Copy Service"
        data-step="status" disabled>
        <em class="fas fa-copy fa-lg"></em>
        </button>`;
    return [startDiv, view, edit, clone, '</div>'].join('');
};


/**
 * serviceNameFormatter
 * @param {string} value - the field value.
 * @param {object} row - the row record data.
 * @param {integer} index the row index
 */
window.serviceNameFormatter = function(value, row, index) {

    let startDiv = `<div class="d-flex justify-content-between">`;
    let view = `<span>${value}</span>` + `<span><a href="/service-directory/service/${row.service_id}/${row.organisation_id}" ` +
            `data-id="${row.id}" data-status="${row.status}" class="view">` +
            `<button class="btn btn-sm btn-primary">View Service</button>` +
            `</a></span>`;

    return [startDiv, view, '</div>'].join('');

};


/**
 * This injects the data into the bootstrap-table template for the custom view
 *
 * @param {*} data - the templates to be processed
 * @returns - The html for the cusom view,
 */
window.serviceDirectoryCustomViewFormatter = function(data) {

    let template = $('#customViewTemplate').html()
    let view = ''
    $.each(data, function (i, row) {
      view += template.replace('%SERVICE_NAME%', row.service_name)
        .replace('%ORGANISATION_NAME%', row.organisation_name)
        .replace('%SERVICE_START%', convertDate(row.service_start))
        .replace('%SERVICE_DESCRIPTION%', row.service_description)
        .replace('%URL%', "/service-directory/service/" + row.service_id + "/" + row.organisation_id)
        .replace('%SERVICE_ID%', row.service_id)
        .replace('%ORGANISATION_ID%', row.organisation_id)
    })

    return `<div class="row mx-0">${view}</div>`
}


/**
 * convertDate transforms timestamp value in readable date
 * @param {string} timeStamp - the field value.
 */
let convertDate = function (timeStamp) {

  let a = new Date(timeStamp * 1000);
  let months = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
  return a.getDate() + ' ' + months[a.getMonth()] + ' ' +  a.getFullYear();

}

// set bootstrap-table click handlers for clone and edit icons
// see https://examples.bootstrap-table.com/index.html#column-options/events.html for example
window.operateEvents = {

    'click .clone': function(event, value, row, index) {
        $('#clone-service').attr('data-request', row.id);
    },
    'click .edit': function(event, value, row, index) {
        window.location.href = `/service-directory/edit-service/${row.service_id}`;
    }
}
